export default "__VITE_ASSET__DxUp5ZaM__"